module.exports = __webpack_public_path__ + "img/journey-email-template-non-graphical.c4e485d5.png";